/**
 * Adapter that normalizes the two sources of cancellation history the frontend
 * has to deal with:
 *
 *   1) The legacy `news.cancellations` block - a cumulative summary baked into
 *      the Statistics document. Its `totalCancellations` and `dateCounts` are
 *      lifetime, not last-30-days, even though the UI has historically labeled
 *      them that way.
 *
 *   2) The new `news.analytics.last30d` block - a true rolling 30-day window
 *      computed from CancellationEvent documents.
 *
 * Consumers (NewsBar, CancellationStats, etc.) should call this once and use
 * the returned object so the same "last 30 days" copy stays honest no matter
 * which source backs it.
 */
export function getCancellationView(news) {
  const legacy = news?.cancellations || null;
  const analytics = news?.analytics || null;
  const last30d = analytics?.last30d || null;

  if (last30d && (last30d.total ?? 0) > 0) {
    return {
      source: 'analytics',
      outingName: analytics.outingName || legacy?.outingName || '',
      totalSpots: last30d.total,
      dateCounts: last30d.byDate || {},
      lastUpdated: last30d.lastDetectedAt || null,
      isLast30Days: true,
      peakSeason: analytics.peakSeason || null,
    };
  }

  if (legacy && (legacy.totalCancellations ?? 0) > 0) {
    return {
      source: 'legacy',
      outingName: legacy.outingName || '',
      totalSpots: legacy.totalCancellations,
      dateCounts: legacy.dateCounts || {},
      lastUpdated: legacy.lastUpdated || null,
      isLast30Days: false,
      peakSeason: legacy.peakSeason || null,
    };
  }

  return null;
}
